import HotkeyField from './HotkeyField.tsx';

export default HotkeyField;
